import { useContext } from 'react'
import PropTypes from 'prop-types'
import { Badge } from '@leroy-merlin-br/backyard-react-ui'

import ShapeThumb from 'reactGarden/common/prop-types/ThumbContent'
import { HeartIcon } from 'reactGarden/HeartIcon'
import Glyph from 'reactGarden/Glyph'

import { WishlistContext } from 'reactSite/Wishlist/context'

import * as S from './styled'

const ThumbFlags = ({ data: { id, inWishList, products } }) => {
  const { onPressHeart, isOnWishlist } = useContext(WishlistContext)

  const wishlistAction = () => onPressHeart({ inWishList, id }, 'contents')

  return (
    <S.FlagsWrapper>
      <S.FlagsOffers>
        <Glyph glyph="tag" />

        <S.BadgeWrapper>
          <Badge color="green">
            {products.length}
          </Badge>
        </S.BadgeWrapper>
      </S.FlagsOffers>

      <HeartIcon onClick={wishlistAction} isActive={isOnWishlist(id)} />
    </S.FlagsWrapper>
  )
}

ThumbFlags.propTypes = {
  data: PropTypes.shape({ ...ShapeThumb }).isRequired
}

export default ThumbFlags
